import * as yup from 'yup';
import { LoginFormData } from './LoginPage/types';
import { ForgotPasswordFormData } from './ForgotPasswordPage/types';
import { ResetPasswordFormData } from './ResetPasswordPage/types';

export const loginSchema = yup.object({
  emailOrUsername: yup
    .string()
    .required('Email or username is required')
    .min(3, 'Email or username must be at least 3 characters')
    .defined(),
  password: yup
    .string()
    .required('Password is required')
    .min(6, 'Password must be at least 6 characters')
    .defined(),
}) as yup.ObjectSchema<LoginFormData>;

export const forgotPasswordSchema = yup.object({
  email: yup
    .string()
    .required('Email is required')
    .email('Please enter a valid email address')
    .defined(),
}) as yup.ObjectSchema<ForgotPasswordFormData>;

export const resetPasswordSchema = yup.object({
  password: yup
    .string()
    .required('Password is required')
    .min(8, 'Password must be at least 8 characters long')
    .matches(/(?=.*[a-z])/, 'Password must contain at least one lowercase letter')
    .matches(/(?=.*[A-Z])/, 'Password must contain at least one uppercase letter')
    .matches(/(?=.*\d)/, 'Password must contain at least one number')
    .defined(),
  confirmPassword: yup
    .string()
    .required('Please confirm your password')
    .oneOf([yup.ref('password')], 'Passwords must match')
    .defined(),
}) as yup.ObjectSchema<ResetPasswordFormData>;

export const resetPasswordCodeSchema = yup.object({
  password: yup
    .string()
    .required('Password is required')
    .min(6, 'Password must be at least 6 characters long')
    .max(20, 'Password must be at most 20 characters long')
    .matches(/(?=.*[a-z])/, 'Password must contain at least one lowercase letter')
    .matches(/(?=.*[A-Z])/, 'Password must contain at least one uppercase letter')
    .matches(/(?=.*\d)/, 'Password must contain at least one number')
    .defined(),
  confirmPassword: yup
    .string()
    .required('Please confirm your password')
    .oneOf([yup.ref('password')], 'Passwords must match')
    .defined(),
}) as yup.ObjectSchema<ResetPasswordFormData>;
